import axios from 'axios';

const API_BASE = '/api';

export const attachmentService = {
  // List attachments for a quote
  getForQuote: async (quoteId) => {
    const response = await axios.get(`${API_BASE}/quotes/${quoteId}/attachments`);
    return response.data;
  },

  // List attachments for a work order
  getForWorkOrder: async (workOrderId) => {
    const response = await axios.get(`${API_BASE}/work-orders/${workOrderId}/attachments`);
    return response.data;
  },

  // List attachments for a purchase order
  getForPurchaseOrder: async (purchaseOrderId) => {
    const response = await axios.get(`${API_BASE}/attachments/purchase-orders/${purchaseOrderId}`);
    return response.data;
  },

  // List attachments for a shipment-in record
  getForShipmentIn: async (shipmentInId) => {
    const response = await axios.get(`${API_BASE}/attachments/shipments-in/${shipmentInId}`);
    return response.data;
  },

  // List attachments for a customer (same pattern as getForQuote)
  getForCustomer: async (customerId) => {
    const response = await axios.get(`${API_BASE}/customers/${customerId}/attachments`);
    return response.data;
  },

  getForVendor: async (vendorId) => {
    const response = await axios.get(`${API_BASE}/vendors/${vendorId}/attachments`);
    return response.data;
  },

  // Upload a new attachment. Pass one parent id: quote, work order, PO, shipment-in, customer, or vendor.
  upload: async ({ file, quoteId, workOrderId, purchaseOrderId, receiverId, shipmentInId, customerId, vendorId }) => {
    const formData = new FormData();
    formData.append('file', file);
    if (quoteId) formData.append('quote_id', String(quoteId));
    if (workOrderId) formData.append('work_order_id', String(workOrderId));
    if (purchaseOrderId) formData.append('purchase_order_id', String(purchaseOrderId));
    if (shipmentInId) formData.append('shipment_in_id', String(shipmentInId));
    if (receiverId) formData.append('receiver_id', String(receiverId));
    if (customerId) formData.append('customer_id', String(customerId));
    if (vendorId) formData.append('vendor_id', String(vendorId));

    const response = await axios.post(`${API_BASE}/attachments`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Delete attachment
  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/attachments/${id}`);
    return response.data;
  },

  // Download URL helper
  getDownloadUrl: (id) => `${API_BASE}/attachments/${id}/download`,

  // Download attachment as a Blob (auth header is included via axios defaults)
  download: async (id) => {
    return axios.get(`${API_BASE}/attachments/${id}/download`, {
      responseType: 'blob',
    });
  },
};

// Backward-compatible aliases during receiver -> shipment-in rename.
attachmentService.getForReceiver = attachmentService.getForShipmentIn;

